export enum MembershipLevel {
  EVERYONE = 'Silver',
  DIAMOND = 'Diamond',
  ADMIN = 'ADMIN',
}

export enum MembershipLevelValue {
  EVERYONE = 0,
  DIAMOND = 50,
  ADMIN = 100,
}

export enum MembershipReferralStatus {
  CONFIRMED = 'CONFIRMED',
}

export enum MembershipReferralEvent {
  CREATED = 'TL_MEMBERSHIP_REFERRAL_CREATED_EVENT',
}

export enum MembershipStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  CANCEL_PENDING = 'CANCEL_PENDING',
  PAST_DUE = 'PAST_DUE',
  CANCELLED = 'CANCELLED',
}

export const MembershipLevelMin = MembershipLevelValue.EVERYONE
export const MembershipLevelMax = MembershipLevelValue.ADMIN

export enum MembershipPerkType {
  LINE_JUMPER = 'LINE_JUMPER',
  FREE_ENTRY = 'FREE_ENTRY',
  DRINK_DEAL = 'DRINK_DEAL',
  BRING_A_FRIEND = 'BRING_A_FRIEND',
  MEMBER_EVENT = 'MEMBER_EVENT',
  TABLE_SPECIALS = 'TABLE_SPECIALS',
}

export enum MembershipReferralType {
  USER = 'USER',
}

export enum MembershipErrorMessage {
  MEMBERSHIP_ALREADY_EXISTS = 'It looks like you already have a membership for this account',
  INVALID_PLAN = 'Membership plan is not valid',
  INVALID_PAYMENT_PROFILE = 'There was an issue with with your payment',
  MEMBERSHIP_ALREADY_ACTIVE = 'Membership is already active',
  MEMBERSHIP_NOT_ACTIVE = 'Membership is not active',
  MEMBERSHIP_NOT_PAST_DUE = 'Membership is not past due',
  MEMBERSHIP_ALREADY_CANCELLED = 'Membership is already cancelled',
  BILLING_GENERIC_ACTIVATE_ERROR = 'There was a problem activating billing for your membership',
  BILLING_ALREADY_ACTIVE = 'Billing is already active for membership',
  BILLING_GENERIC_DEACTIVATE_ERROR = 'There was a problem deactivating billing for membership',
  STRIPE_GENERIC = 'Something went wrong. Please try again soon.',
}

export enum MembershipDiscountErrorMessage {
  PROMO_CREDIT = 'Promo for credit cannot be used',
  PROMO_NOT_MEMBERSHIP_TYPE = 'Only Promos for membership can be used',
  PROMO_NOT_FOUND = 'Promo not found',
  PROMO_NOT_VALID = 'Promo is no longer valid',
  PROMO_ONLY_FREE_TRIAL = 'Only Promos for free trial can be redeemed',
  PROMO_INVALID_PLAN = 'Promo does not apply for this plan',
  USER_REFERRAL_SAME_USER = 'You cannot use your own referral code',
  USER_REFERRAL_NOT_FOUND = 'User Referral is not valid',
  USER_REFERRAL_BY_NON_MEMBER = 'You can only be referred by a current member',
  INVALID_PLAN = 'Membership plan is not valid',
  MONTHLY_PLAN_ONLY = 'Only valid for a monthly plan',
  DISCOUNT_AMOUNT_GTE_ZERO = 'amount must be greater than or equal to 0',
  ONLY_NEW_MEMBERS = 'The promo code is only valid for new members',
}

export enum MembershipEvent {
  CREATED = 'TL_MEMBERSHIP_CREATED',
  CANCELLED = 'TL_MEMBERSHIP_CANCELLED',
}

export enum MembershipPlanId {
  MONTHLY = 'PLAN_1_ID',
  YEARLY = 'PLAN_2_ID',
}

export const MembershipStatusDescription = {
  ACTIVE_DESCRIPTION: 'Your membership is currently active',
  PAST_DUE_DESCRIPTION:
    'It looks like there was a problem with your payment. If you have any questions, please reach out to your Tablelist Concierge',
  CANCELLED_DESCRIPTION: 'Your membership is canceled',
} as const
